export const SIGN_UP_INITIAL_VALUES = {
  name: '',
  password: '',
  email: '',
  'terms-of-service': false,
  'privacy-policy': false,
}

export const TERMS_OF_SERVICE_PRIVACY_POLICY_ERROR =
  'You need to agree to the Terms of Service and Privacy Policy to continue'
